import { computed } from '@ember/object';
import { belongsTo, hasMany, attr } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
  role: attr('string', {defaultValue: 'contributor'}),
  isConfirmed: attr('boolean', {defaultValue: false}),
  isHidden: attr('boolean', {defaultValue: true}),
  rank: attr('number', {defaultValue: 0}),

  project: belongsTo('project', { async: false }),
  services: hasMany('service', { async: false }),
  user: belongsTo('user', { async: false }),

  isPublic: computed('project.isPublished', 'isHidden', function () {
    return !this.get('isHidden') && this.get('project.isPublished');
  })
});
